import ApiBase from '../ApiBase';

class ToDoList extends ApiBase {
    route = '/to-do-list';
}

export default new ToDoList();
